import React from 'react';
import path from 'path';

const FileExt = ({ src }) => {
	return <i>{path.extname(src).split('?')[0]}</i>;
};

export default FileExt;
